import styled from 'styled-components';
import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';

export const Container = styled.div<{ $color: string }>`
  display: flex;
  align-items: flex-start;
  gap: 15rem;
  margin-bottom: 30rem;
  padding: 20rem 25rem;
  border-radius: 10rem;
  border: 1px solid ${({ $color }: { $color: string }) => $color};
  background-color: ${COLORS.WHITE};

  ${respondTo.bigPhone`
    padding: 15rem;
    gap: 10rem;
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  min-width: 0;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 18rem;
  line-height: 27rem;
  font-weight: 300;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 15rem;
    line-height: 22rem;
  `}
`;

export const Reason = styled.p`
  margin: 0;
  font-size: 15rem;
  line-height: 22rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  opacity: 0.75;
  overflow-wrap: anywhere;
`;
